import React, { useEffect, useRef, useState } from 'react';
import { STDStyle, Buttons, BoxInput } from '../../style';
import Std from '../../../stdPages/std';
import Text from '@/components/Text';
import * as w from '@/helpers_site/textsSite';
import Button from '@/components/Button';
import ButtonBack from '@/components/ButtonBack';
import InputText from '@/components/InputText';
import { validateLoginFields } from '../helpers';
import { loginWithPasskey } from '../passKeyFn';
import { useStepGate } from '../usetStepGate';

import { api } from '@/utils/http';  

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);

  const [step, setStep] = useState('email'); // 'email' | 'choose' | 'password'
  const [passkeyOptions, setPasskeyOptions] = useState(null);

  const conditionalStartedRef = useRef(false);
  const { loading, allowed } = useStepGate(`/auth/status/login-status`);
  

  // Conditional UI silencioso (estilo GitHub)
  // useEffect(() => {
  //   if (loading || !allowed) return;
  //   if (conditionalStartedRef.current) return;
  //   conditionalStartedRef.current = true;
  //   initConditionalPasskeyLogin().catch(() => { });
  // }, [loading, allowed]);

  if (loading || !allowed) return null;

  // PASSO 1: Continuar com email
  const onContinue = async () => {
    const { isValid, normalized } = validateLoginFields(
      { email },
      { email: setErrorEmail },
      { requiredFields: ["email"], maxLen: 100 }
    );
    if (!isValid) return;

    try {
      const { data } = await api.post(`auth/webnnauth/authentication/options`, {
        email: normalized.email,
      });

      if (data?.hasPasskey) {
        setPasskeyOptions(data.options);
        setStep('choose');
      } else {
        setStep('password');
      }
    } catch (err) {
      const msg = err?.response?.data?.status || w.INVALID_CREDENTIALS;
      setErrorEmail(msg);
    }
  };

  // PASSO 2A: Entrar com passkey
  const onSubmitPassKey = async () => {
    try {
      const resp = await loginWithPasskey(email);
      if (resp?.redirect) window.location.assign(resp.redirect);
    } catch (err) {
      const msg = err?.response?.data?.status || w.INVALID_CREDENTIALS;
      setErrorEmail(msg);
      // mantém step='choose' e oferece "Usar senha"
    }
  };

  // PASSO 2B: Usar senha
  const onUsePassword = () => {
    setStep('password');
  };

  // PASSO 3: Login tradicional
  const onSubmitLogin = async () => {
    const { isValid, normalized } = validateLoginFields(
      { email, password },
      { email: setErrorEmail, password: setErrorPassword },
      { requiredFields: ["email", "password"], maxLen: 100 }
    );
    if (!isValid) return;

    try {
      const { data } = await api.post(`auth/admin/loginAuth1`, {
        email: normalized.email,
        passwordData: normalized.password,
      });

      if (data?.redirect) window.location.assign(data.redirect);
    } catch (err) {
      const msg = err?.response?.data?.status || w.INVALID_CREDENTIALS;
      setErrorEmail(msg);
      setErrorPassword(msg);
    }
  };

  return (
    <Std id='front' withoutMenu={true}>
      <STDStyle>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '50px' }}>
          <Text title={w.Login} $family='head' color={'rgb(0,14,38)'} typeFont='head' tag='h3Small' />
          <BoxInput>

            {/* Email sempre visível */}
            <InputText
              name={email}
              value={email}
              onChange={e => setEmail(e.target.value)}
              legend="Email"
              typeTxt="text"
              placeholder="Digite seu email"
              error={errorEmail}
              required
              maxCaracter={50}
              onFocus={() => setErrorEmail('')}
            />

            {/* Passo 1: Continuar */}
            {/* {step === 'email' && (
              <Buttons>
                <Button handle={onContinue} text="Continuar" />
              </Buttons>
            )} */}

            {/* Passo 2: Escolha */}
            {/* {step === 'choose' && (
              <Buttons>
                <div style={{display:'flex', gap: '16px'}}>
                  <ButtonBack minWid="180px" handle={onSubmitPassKey} text="Entrar com Passkey" />
                  <Button handle={onUsePassword} text="Usar senha" />
                </div>
              </Buttons>
            )} */}

           
              <>
                <InputText
                  name={password}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  legend="Senha"
                  typeTxt="password"
                  placeholder="Digite sua senha"
                  error={errorPassword}
                  required
                  maxCaracter={100}
                  onFocus={() => setErrorPassword('')}
                />
                <Buttons>
                  <Button handle={onSubmitLogin} text="Login" />
                </Buttons>
              </>
            

          </BoxInput>
        </div>
      </STDStyle>
    </Std>
  );
};

export default Login;
